import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ShopAdminListLayer from "../components/ShopAdminListLayer";

const ShopCreatePage = () => {
  return (
    <>
      <MasterLayout>
        <ShopAdminListLayer />
      </MasterLayout>
    </>
  );
};

export default ShopCreatePage;
